import { useState } from 'react'
import { PLANS } from '../content/site'

const [proPlan, teamPlan] = PLANS
const proFeatures = proPlan.features
const teamFeatures = teamPlan.features

export default function PricingSection() {
  const [annual, setAnnual] = useState(false)

  const proPrice = annual ? proPlan.annualMonthly : proPlan.monthly
  const teamPrice = annual ? teamPlan.annualMonthly : teamPlan.monthly
  const proSave = annual ? 'Save 20%' : null
  const teamSave = annual ? 'Save 20%' : null
  const intervalParam = annual ? 'annual' : 'monthly'
  const proCtaHref = `https://app.procuralerts.com/register?plan=pro&interval=${intervalParam}`
  const teamCtaHref = `https://app.procuralerts.com/register?plan=team&interval=${intervalParam}`

  return (
    <section id="pricing" style={{ background: '#0d1117', padding: 'clamp(80px,12vh,160px) 0' }}>
      <div style={{ maxWidth: 900, margin: '0 auto', padding: '0 1rem' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <p style={{ fontSize: '0.75rem', fontFamily: 'monospace', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#06b6d4', marginBottom: '0.5rem' }}>PRICING</p>
          <h2 style={{ fontSize: 'clamp(28px,3vw,42px)', fontWeight: 700, color: '#f0f6fc', marginBottom: '0.4rem' }}>Simple, transparent pricing</h2>
          <p style={{ color: '#9ca3af', fontSize: '0.9rem' }}>14-day free trial on all plans. Cancel anytime.</p>
        </div>

        {/* Annual toggle */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '0.75rem', marginBottom: '2.5rem' }}>
          <span style={{ fontSize: '0.85rem', color: annual ? '#9ca3af' : '#e6edf3', fontWeight: 600, transition: 'color 0.2s' }}>Monthly</span>
          <button
            onClick={() => setAnnual(!annual)}
            style={{
              position: 'relative',
              width: 44,
              height: 24,
              borderRadius: 999,
              border: 'none',
              cursor: 'pointer',
              background: annual ? '#06b6d4' : '#374151',
              transition: 'background 0.2s',
              padding: 0,
            }}
            aria-label="Toggle annual billing"
          >
            <span style={{
              position: 'absolute',
              top: 2,
              left: annual ? 22 : 2,
              width: 20,
              height: 20,
              borderRadius: '50%',
              background: '#fff',
              transition: 'left 0.2s',
            }} />
          </button>
          <span style={{ fontSize: '0.85rem', color: annual ? '#e6edf3' : '#9ca3af', fontWeight: 600, transition: 'color 0.2s' }}>Annual</span>
          {annual && <span style={{ fontSize: '0.68rem', fontWeight: 700, color: '#000', background: '#22c55e', padding: '2px 8px', borderRadius: 999 }}>Save 20%</span>}
        </div>

        {/* Cards */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', alignItems: 'stretch' }}>
          {/* Pro */}
          <div style={{
            background: '#161b22',
            border: '1px solid #06b6d4',
            boxShadow: '0 0 0 1px #06b6d4',
            borderRadius: 12,
            padding: '2rem 1.75rem',
            display: 'flex',
            flexDirection: 'column' as const,
            position: 'relative' as const,
          }}>
            <span style={{
              position: 'absolute', top: -11, left: '50%', transform: 'translateX(-50%)',
              fontSize: '0.68rem', fontWeight: 700, padding: '3px 12px',
              borderRadius: 999, whiteSpace: 'nowrap' as const, letterSpacing: '0.06em',
              textTransform: 'uppercase' as const,
              background: '#06b6d4', color: '#000',
            }}>Most Popular</span>

            <div style={{ fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase' as const, letterSpacing: '0.1em', color: '#9ca3af', marginBottom: '0.6rem' }}>Pro</div>

            <div style={{ fontSize: '2.2rem', fontWeight: 800, color: '#f0f6fc', lineHeight: 1 }}>
              ${proPrice} <span style={{ fontSize: '0.85rem', fontWeight: 400, color: '#9ca3af' }}>/ mo</span>
            </div>
            {annual && (
              <div style={{ fontSize: '0.78rem', color: '#22c55e', marginTop: 4 }}>${proPrice * 12} billed annually {proSave && <span style={{ color: '#f59e0b', marginLeft: 6 }}>{proSave}</span>}</div>
            )}

            <div style={{ fontSize: '0.85rem', color: '#9ca3af', margin: '0.75rem 0 1.25rem' }}>For individual contractors</div>
            <hr style={{ border: 'none', borderTop: '1px solid #21262d', margin: '0 0 1.25rem' }} />

            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem', flex: 1 }}>
              {proFeatures.map((f, i) => (
                <li key={i} style={{ display: 'flex', gap: '0.5rem', padding: '0.3rem 0', fontSize: '0.84rem', color: '#e6edf3', alignItems: 'flex-start' }}>
                  <span style={{ flexShrink: 0, fontWeight: 700, color: '#22c55e' }}>{i === proFeatures.length - 1 ? '\u2713' : '\u2713'}</span>
                  {f}
                </li>
              ))}
            </ul>

            <a href={proCtaHref} style={{
              display: 'block', textAlign: 'center' as const, padding: '0.7rem 1rem',
              borderRadius: 8, fontSize: '0.9rem', fontWeight: 600,
              textDecoration: 'none', cursor: 'pointer',
              background: '#06b6d4', color: '#000',
            }}>Start 14-day free trial &rarr;</a>
          </div>

          {/* Team */}
          <div style={{
            background: '#161b22',
            border: '1px solid #21262d',
            borderRadius: 12,
            padding: '2rem 1.75rem',
            display: 'flex',
            flexDirection: 'column' as const,
          }}>
            <div style={{ fontSize: '0.78rem', fontWeight: 700, textTransform: 'uppercase' as const, letterSpacing: '0.1em', color: '#9ca3af', marginBottom: '0.6rem' }}>Team</div>

            <div style={{ fontSize: '2.2rem', fontWeight: 800, color: '#f0f6fc', lineHeight: 1 }}>
              ${teamPrice} <span style={{ fontSize: '0.85rem', fontWeight: 400, color: '#9ca3af' }}>/ mo</span>
            </div>
            {annual && (
              <div style={{ fontSize: '0.78rem', color: '#22c55e', marginTop: 4 }}>${teamPrice * 12} billed annually {teamSave && <span style={{ color: '#f59e0b', marginLeft: 6 }}>{teamSave}</span>}</div>
            )}

            <div style={{ fontSize: '0.85rem', color: '#9ca3af', margin: '0.75rem 0 1.25rem' }}>For companies with up to 5 users</div>
            <hr style={{ border: 'none', borderTop: '1px solid #21262d', margin: '0 0 1.25rem' }} />

            <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 1.5rem', flex: 1 }}>
              {teamFeatures.map((f, i) => (
                <li key={i} style={{ display: 'flex', gap: '0.5rem', padding: '0.3rem 0', fontSize: '0.84rem', color: i === 0 ? '#9ca3af' : '#e6edf3', alignItems: 'flex-start' }}>
                  <span style={{ flexShrink: 0, fontWeight: 700, color: i === 0 ? '#9ca3af' : '#22c55e' }}>{i === 0 ? '\u2192' : '\u2713'}</span>
                  {f}
                </li>
              ))}
            </ul>

            <a href={teamCtaHref} style={{
              display: 'block', textAlign: 'center' as const, padding: '0.7rem 1rem',
              borderRadius: 8, fontSize: '0.9rem', fontWeight: 600,
              textDecoration: 'none', cursor: 'pointer',
              background: '#06b6d4', color: '#000',
            }}>Start 14-day free trial &rarr;</a>
          </div>
        </div>

        <p style={{ textAlign: 'center', marginTop: '2rem', color: '#9ca3af', fontSize: '0.8rem', lineHeight: 1.8 }}>
          14-day free trial on all plans &middot; Cancel anytime
        </p>
      </div>
    </section>
  )
}
